[
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "https://json-schema.org/v1",
    "shortName": "v1",
    "prettyName": "v1",
    "prerelease": true,
    "aliases": ["draft-next"]
  },
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "https://json-schema.org/draft/2020-12/schema",
    "shortName": "draft2020-12",
    "prettyName": "Draft 2020-12",
    "firstPublicationDate": "2020-01-28",
    "aliases": ["2020", "202012", "2020-12", "draft202012"]
  },
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "https://json-schema.org/draft/2019-09/schema",
    "shortName": "draft2019-09",
    "prettyName": "Draft 2019-09",
    "firstPublicationDate": "2019-09-17",
    "aliases": ["2019", "201909", "2019-09", "draft201909"]
  },
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "http://json-schema.org/draft-07/schema#",
    "shortName": "draft7",
    "prettyName": "Draft 7",
    "firstPublicationDate": "2017-11-19",
    "aliases": ["7"]
  },
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "http://json-schema.org/draft-06/schema#",
    "shortName": "draft6",
    "prettyName": "Draft 6",
    "firstPublicationDate": "2017-04-21",
    "aliases": ["6"]
  },
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "http://json-schema.org/draft-04/schema#",
    "shortName": "draft4",
    "prettyName": "Draft 4",
    "firstPublicationDate": "2013-01-31",
    "hasBooleanSchemas": false,
    "aliases": ["4"]
  },
  {
    "$schema": "tag:bowtie.report,2024:models:dialect",
    "uri": "http://json-schema.org/draft-03/schema#",
    "shortName": "draft3",
    "prettyName": "Draft 3",
    "firstPublicationDate": "2010-11-22",
    "hasBooleanSchemas": false,
    "aliases": ["3"],
    "bottom": {
      "$schema": "http://json-schema.org/draft-03/schema#",
      "disallow": [{}]
    }
  }
]
